import {
    faFacebookSquare,
    faInstagram,
    faTwitter,
    faLinkedin,
    faWhatsapp,
    faMedium
} from '@fortawesome/free-brands-svg-icons';
import {
    DISCOURSE_PERSONAS,
    DISQUALIFICATION_TYPES
} from '@nexxt/common/types';

export const devices = [
    { value: 'browser', label: 'Desktop', title: 'desktop' },
    { value: 'tablet', label: 'Tablet', title: 'tablet' },
    { value: 'mobile', label: 'Mobile', title: 'mobile' }
];

export const deviceMapping = {
    browser: devices[0],
    tablet: devices[1],
    mobile: devices[2]
};

export const sharingGroupAll = [
    {
        label: 'No sharing',
        value: 'no_sharing'
    },
    {
        label: 'Project Specific',
        value: 'project_specific'
    },
    {
        label: 'Global',
        value: 'global'
    }
];

export const sharingGroup = [
    {
        label: 'No sharing',
        value: 'no_sharing',
        disabled: true
    },
    {
        label: 'Project Specific',
        value: 'project_specific',
        disabled: true
    },
    {
        label: 'Global',
        value: 'global'
    }
];

export const SOCIAL_MEDIA = [
    {
        label: 'Facebook',
        source: 'fb',
        icon: faFacebookSquare
    },
    {
        label: 'Instagram',
        source: 'ig',
        icon: faInstagram
    },
    {
        label: 'Twitter',
        source: 'tw',
        icon: faTwitter
    },
    {
        label: 'LinkedIn',
        source: 'li',
        icon: faLinkedin
    },
    {
        label: 'Whatsapp',
        source: 'wa',
        icon: faWhatsapp
    },
    {
        label: 'Medium',
        source: 'me',
        icon: faMedium
    }
];

export const surveyTopics = [
    {
        value: 'AUTOMOTIVE',
        label: 'Automotive'
    },
    {
        value: 'BEVERAGES_ALCOHOLIC',
        label: 'Beverages - Alcoholic'
    },
    {
        value: 'BEVERAGES_NON_ALCOHOLIC',
        label: 'Beverages - Non Alcoholic'
    },
    {
        value: 'BUSINESS',
        label: 'Business'
    },
    {
        value: 'CHILDREN_PARENTING',
        label: 'Children & Parenting'
    },
    {
        value: 'LOYALTY_PROGRAMS',
        label: 'Coalition/Loyalty Programs'
    },
    {
        value: 'DESTINATIONS_TOURISM',
        label: 'Destinations & Tourism'
    },
    {
        value: 'EDUCATION',
        label: 'Education'
    },
    {
        value: 'ELECTRICS_COMPUTERS',
        label: 'Electronics/Computer/Software'
    },
    {
        value: 'ENTERTAINMENT_LEISURE',
        label: 'Entertainment & Leisure'
    },
    {
        value: 'FASHION_CLOTHING',
        label: 'Fashion & Clothing - Other'
    },
    {
        value: 'FINANCE',
        label: 'Finance, Banking, Investing & Insurance'
    },
    {
        value: 'FOOD',
        label: 'Food'
    },
    {
        value: 'GAMBLING_LOTTERY',
        label: 'Gambling/Lottery'
    },
    {
        value: 'GOVERNMENT_POLITICS',
        label: 'Government & Politics'
    },
    {
        value: 'HEALTHCARE',
        label: 'Healthcare'
    },
    {
        value: 'HOME',
        label: 'Home'
    },
    {
        value: 'MEDIA_PUBLISHING',
        label: 'Media & Publishing'
    },
    {
        value: 'PERSONAL_CARE',
        label: 'Personal Care (Toiletries, Beauty, Cosmetics)'
    },
    {
        value: 'RESTAURANTS',
        label: 'Restaurants'
    },
    {
        value: 'SENSITIVE_CONTENT',
        label: 'Sensitive/Explicit Content'
    },
    {
        value: 'SMOKING',
        label: 'Smoking/Tobacco'
    },
    {
        value: 'SOCIAL_RESEARCH',
        label: 'Social Research'
    },
    {
        value: 'SPORTS_FITNESS',
        label: 'Sports, Recreation, Fitness'
    },
    {
        value: 'TELECOMMUNICATIONS',
        label: 'Telecommunications'
    },
    {
        value: 'TRANSPORTATION',
        label: 'Transportation'
    },
    {
        value: 'TRAVEL_AIRLINES',
        label: 'Travel - Airlines'
    },
    {
        value: 'TRAVEL_HOTELS',
        label: 'Travel - Hotels'
    },
    {
        value: 'TRAVEL_SERVICES',
        label: 'Travel Services/Agency/Booking'
    },
    {
        value: 'CREDIT_CARDS',
        label: 'Credit Cards'
    },
    {
        value: 'FASHION_CLOTHING_DEPARTMENT_STORE',
        label: 'Fashion & Clothing - Department Store'
    }
];

export const disqualificationFullServiceMapping = [
    {
        label: 'Strict - 5 Demerit Points',
        value: DISQUALIFICATION_TYPES.STRICT
    },
    {
        label: 'Normal - 10 Demerit Points',
        value: DISQUALIFICATION_TYPES.NORMAL
    },
    { label: 'Disable', value: DISQUALIFICATION_TYPES.DISABLE }
];

export const disqualificationSelfServiceMapping = [
    { label: 'Enable', value: DISQUALIFICATION_TYPES.STRICT },
    { label: 'Disable', value: DISQUALIFICATION_TYPES.DISABLE }
];

export const discoursePersonasMapping = [
    { label: 'Casual and upbeat', value: DISCOURSE_PERSONAS.DEFAULT },
    { label: 'Formal and professional', value: DISCOURSE_PERSONAS.FORMAL }
];
